// extracted by mini-css-extract-plugin
module.exports = {"panel":"AssigneesPanel_panel__PcUU6","title":"AssigneesPanel_title__3xC2w"};